import templateUrl from '../views/modals/bulk-message-modal.tpl.html';
import PicklistContactBulkMessageModalController from '../controllers/modals/bulk-send/picklist-contact-bulk-message-modal';

export default function picklistContactBulkMessageModalCreator($injector, recipientsStore, picklist, extendedInformation) {
    extendedInformation = _.isObject(extendedInformation) ? extendedInformation : {};

    return $injector.get('$uibModal').open({
        controller: PicklistContactBulkMessageModalController,
        controllerAs: 'vm',
        size: 'xlg',
        templateUrl,
        backdrop: 'static',
        windowClass: 'modal-fixed',
        keyboard: false,
        resolve: {
            extendedInformation: () => ({
                ...extendedInformation,
                recipientsStore,
                picklist
            })
        }
    }).result;
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/helpers/picklist-contact-bulk-message-modal-creator.js